var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRepartitionIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 4.16655C10.001 3.83324 9.93532 3.5031 9.80685 3.19555C9.67837 2.88799 9.4897 2.60923 9.25191 2.37567C9.01413 2.1421 8.73204 1.95844 8.42224 1.83549C8.11243 1.71254 7.78117 1.65278 7.44793 1.65972C7.1147 1.66667 6.78621 1.74018 6.4818 1.87593C6.17739 2.01169 5.9032 2.20694 5.67536 2.45022C5.44751 2.69349 5.27061 2.97987 5.15506 3.29251C5.03952 3.60515 4.98765 3.93774 5.00252 4.27071C4.51269 4.39666 4.05794 4.63242 3.67271 4.96014C3.28749 5.28786 2.98189 5.69894 2.77906 6.16225C2.57623 6.62556 2.48149 7.12896 2.50201 7.63431C2.52254 8.13965 2.65779 8.63371 2.89752 9.07905C2.476 9.42149 2.14454 9.86174 1.93197 10.3615C1.7194 10.8612 1.63215 11.4054 1.67782 11.9465C1.7235 12.4877 1.9007 13.0095 2.19403 13.4666C2.48735 13.9236 2.88791 14.3021 3.36085 14.569C3.30245 15.0209 3.3373 15.4799 3.46326 15.9178C3.58922 16.3557 3.8036 16.7631 4.09318 17.1148C4.38275 17.4666 4.74136 17.7553 5.14687 17.963C5.55238 18.1708 5.99617 18.2932 6.45083 18.3227C6.9055 18.3522 7.36139 18.2881 7.79034 18.1346C8.2193 17.981 8.61221 17.7411 8.94482 17.4297C9.27743 17.1183 9.54267 16.742 9.72416 16.3241C9.90565 15.9062 9.99953 15.4555 10 14.9999V4.16655Z",
    stroke: "#FF4363",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 4.16655C9.99903 3.83324 10.0647 3.5031 10.1932 3.19555C10.3217 2.88799 10.5103 2.60923 10.7481 2.37567C10.9859 2.1421 11.268 1.95844 11.5778 1.83549C11.8876 1.71254 12.2189 1.65278 12.5521 1.65972C12.8853 1.66667 13.2138 1.74018 13.5182 1.87593C13.8226 2.01169 14.0968 2.20694 14.3247 2.45022C14.5525 2.69349 14.7294 2.97987 14.845 3.29251C14.9605 3.60515 15.0124 3.93774 14.9975 4.27071C15.4873 4.39666 15.9421 4.63242 16.3273 4.96014C16.7125 5.28786 17.0181 5.69894 17.221 6.16225C17.4238 6.62556 17.5185 7.12896 17.498 7.63431C17.4775 8.13965 17.3422 8.63371 17.1025 9.07905C17.524 9.42149 17.8555 9.86174 18.0681 10.3615C18.2806 10.8612 18.3679 11.4054 18.3222 11.9465C18.2765 12.4877 18.0993 13.0095 17.806 13.4666C17.5127 13.9236 17.1121 14.3021 16.6392 14.569C16.6976 15.0209 16.6627 15.4799 16.5368 15.9178C16.4108 16.3557 16.1964 16.7631 15.9069 17.1148C15.6173 17.4666 15.2587 17.7553 14.8532 17.963C14.4477 18.1708 14.0039 18.2932 13.5492 18.3227C13.0945 18.3522 12.6386 18.2881 12.2097 18.1346C11.7807 17.981 11.3878 17.7411 11.0552 17.4297C10.7226 17.1183 10.4574 16.742 10.2759 16.3241C10.0944 15.9062 10.0005 15.4555 10 14.9999V4.16655Z",
    stroke: "#FF4363",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 10.8333C11.8004 10.5872 11.1894 10.1392 10.7444 9.54584C10.2994 8.95251 10.0404 8.24056 10 7.5C9.95962 8.24056 9.70056 8.95251 9.25556 9.54584C8.81057 10.1392 8.19963 10.5872 7.5 10.8333",
    stroke: "#FF4363",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.666 5.41683C14.8677 5.06732 14.9818 4.67418 14.9985 4.271",
    stroke: "#FF4363",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.00244 4.271C5.01892 4.67411 5.13272 5.06724 5.33411 5.41683",
    stroke: "#FF4363",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M2.89746 9.08C3.04991 8.95584 3.21305 8.84541 3.38496 8.75",
    stroke: "#FF4363",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6152 8.75C16.7871 8.84541 16.9503 8.95584 17.1027 9.08",
    stroke: "#FF4363",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M5.00001 14.9998C4.4257 15.0001 3.86106 14.852 3.36084 14.5698",
    stroke: "#FF4363",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6392 14.5698C16.1389 14.852 15.5743 15.0001 15 14.9998",
    stroke: "#FF4363",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRepartitionIcon);
export default __webpack_public_path__ + "static/media/repartition_icon.f56d91eae7a8b140bb61b8e62a95a41a.svg";
export { ForwardRef as ReactComponent };